import { useMutation } from 'react-query';
import { InvoiceModel, PaymentOrigin } from '@frontend/api-invoices';
import {
  UseCreatePaymentIntentSyncOptions,
  useInvoicePerson,
  useConfirmStripePaymentViaElements,
} from '../../../../../hooks';

export interface UseStripeManualCardEntryPaymentOptions {
  cardName?: string;
  receiptEmail: string;
  invoice?: InvoiceModel;
  onInvoiceAlreadyPaid: UseCreatePaymentIntentSyncOptions['onInvoiceAlreadyPaid'];
  onRefetchInvoice: UseCreatePaymentIntentSyncOptions['onRefetchInvoice'];
}

export const useStripeManualCardEntryPayment = ({
  cardName,
  receiptEmail,
  invoice,
  onInvoiceAlreadyPaid,
  onRefetchInvoice,
}: UseStripeManualCardEntryPaymentOptions) => {
  const locationId = invoice?.locationId;
  const personId = invoice?.person.id;
  const pmId = invoice?.person?.pmid;
  const { personEmail: email } = useInvoicePerson(invoice);
  const amount = invoice?.billedAmount ?? 0;

  const { makePayment } = useConfirmStripePaymentViaElements({
    amount,
    email,
    personId,
    locationId,
    origin: PaymentOrigin.ManualCardEntry,
    setupFutureUsage: null,
    invoiceId: invoice?.id,
    receiptEmail,
    cardholderName: cardName,
    pmId,
    onInvoiceAlreadyPaid,
    onRefetchInvoice,
  });

  const { mutateAsync: makeManualCardEntryPayment, isLoading: makingManualCardEntryPayment } = useMutation({
    mutationFn: async () => makePayment(),
  });
  return { makeManualCardEntryPayment, makingManualCardEntryPayment };
};
